

























import MoominCategoryCard from "~/themes/fiskarsMoominDefault/components/components/molecules/MoominCategoryCard/MoominCategoryCard.vue";
import SfCarousel from "~/themes/fiskarsMoominDefault/components/components/organisms/SfCarousel/SfCarousel.vue";
import {CategoryCardsInterface} from 'types/index';
import {PropType} from 'vue'
import { defineComponent, reactive} from '@nuxtjs/composition-api';


export default defineComponent({
  name: 'MoominCategoryCardCarousel',
  components: {SfCarousel,MoominCategoryCard},
  props: {
    items: {
      type: Array as PropType<CategoryCardsInterface[]>,
      default: () => [{}],
    },
    title: {
      type: String,
      default: "Collections"
    },
    description: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: "View all"
    },
    link: {
      type: [Object, String],
      default: ""
    }
  },
  setup(props) {
    const carouselSettings = reactive({
        type: "carousel",
        rewind: true,
        perView: 2,
        slidePerPage: true,
        gap: 70,
        breakpoints: {
          1023: {
            perView: 1.1,
            gap: 10,
            peek: {
              before: 0,
              after: 0,
            },
          }
        },
    })
    const getCardBackground = (item) => {
      return item?.background?.selectionValues[0]?.key ? item?.background?.selectionValues[0]?.key : 'var(--c-secondary)';
    }
    const calculateMobileView = (() => props.items.length > 1 ? carouselSettings.breakpoints["1023"].perView = 1.1 : carouselSettings.breakpoints["1023"].perView = 1)();
    return {
      carouselSettings,
      calculateMobileView,
      getCardBackground
    }
  }
})
